import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5047ec08"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-24",
  style: {"padding-left":"10px"}
}
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_generico = _resolveComponent("selecionar-generico")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_selecionar_perfil_usuario = _resolveComponent("selecionar-perfil-usuario")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_generico_string = _resolveComponent("selecionar-generico-string")!
  const _component_selecionar_cor = _resolveComponent("selecionar-cor")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1000,
    destroyOnClose: "",
    centered: "",
    "wrap-class-name": 'scroll-modal ss-modal-vendas'
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Definições da etapa "),
      _createVNode(_component_a_switch, {
        checked: _ctx.state.etapa.totalizador,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.etapa.totalizador) = $event)),
        style: {"float":"right"},
        "checked-children": "Totalizador",
        "un-checked-children": "Totalizador"
      }, null, 8, ["checked"])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
      }, _hoisted_2)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_a_form_item, {
                        label: "Nome",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            maxlength: "250",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.etapa.nome) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.etapa.nome]
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_a_form_item, {
                        label: "Status de Venda",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_generico, {
                            varios: false,
                            "limpar-selecao": false,
                            itens: _ctx.state.statusDisponiveis,
                            mostrarBusca: false,
                            valor: _ctx.state.etapa.statusVenda,
                            "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.etapa.statusVenda) = $event)),
                            disabled: !_ctx.props.editavel
                          }, null, 8, ["itens", "valor", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_a_form_item, {
                        label: "Responsável",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_usuario, {
                            empresas: _ctx.telaBase.empresasSelecionadas,
                            codigosFiltrados: _ctx.usuarios,
                            codigoSelecionado: _ctx.state.etapa.codigoResponsavel,
                            "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.etapa.codigoResponsavel) = $event))
                          }, null, 8, ["empresas", "codigosFiltrados", "codigoSelecionado"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(_component_card, { titulo: "QUEM PODE CONCLUIR ESSA ETAPA" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_a_form_item, {
                            label: "Perfis de Usuários",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_perfil_usuario, {
                                varios: true,
                                codigosFiltrados: _ctx.perfisUsuarios,
                                empresas: _ctx.telaBase.empresasSelecionadas,
                                codigosSelecionados: _ctx.state.perfisUsuarios,
                                "onUpdate:codigosSelecionados": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.perfisUsuarios) = $event))
                              }, null, 8, ["codigosFiltrados", "empresas", "codigosSelecionados"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_a_form_item, {
                            label: "Usuários",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_usuario, {
                                varios: true,
                                empresas: _ctx.telaBase.empresasSelecionadas,
                                codigosFiltrados: _ctx.usuarios,
                                codigosSelecionados: _ctx.state.usuarios,
                                "onUpdate:codigosSelecionados": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.usuarios) = $event))
                              }, null, 8, ["empresas", "codigosFiltrados", "codigosSelecionados"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_form_item, {
                        label: "Etapas Seguintes",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_generico_string, {
                            varios: true,
                            itens: _ctx.state.optionsEtapasDisponiveis,
                            mostrarBusca: false,
                            valoresSelecionados: _ctx.state.proximasEtapas,
                            "onUpdate:valoresSelecionados": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.proximasEtapas) = $event)),
                            disabled: !_ctx.props.editavel
                          }, null, 8, ["itens", "valoresSelecionados", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_a_form_item, {
                        label: "Cor",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_cor, {
                            idComponente: String(_ctx.UtilitarioMatematico.ObterNumeroAleatorio()),
                            cor: _ctx.state.etapa.cor,
                            "onUpdate:cor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.etapa.cor) = $event))
                          }, null, 8, ["idComponente", "cor"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_collapse, {
                ghost: "",
                class: "ss-accordion"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse_panel, {
                    key: "1",
                    header: "GATILHOS DE CONCLUSÃO"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_card, { titulo: "NOTIFICAÇÃO" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_checkbox, {
                                class: "ss-check-box",
                                checked: _ctx.state.etapa.notificarResponsavel,
                                "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.etapa.notificarResponsavel) = $event)),
                                disabled: !_ctx.props.editavel
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Notificar responsável")
                                ]),
                                _: 1
                              }, 8, ["checked", "disabled"]),
                              _createVNode(_component_a_checkbox, {
                                class: "ss-check-box",
                                checked: _ctx.state.etapa.notificarParticipantes,
                                "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.etapa.notificarParticipantes) = $event)),
                                disabled: !_ctx.props.editavel
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Notificar participantes")
                                ]),
                                _: 1
                              }, 8, ["checked", "disabled"]),
                              _createVNode(_component_a_checkbox, {
                                class: "ss-check-box",
                                checked: _ctx.state.etapa.enviarEmailCliente,
                                "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.etapa.enviarEmailCliente) = $event)),
                                disabled: !_ctx.props.editavel
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Enviar e-mail para o cliente")
                                ]),
                                _: 1
                              }, 8, ["checked", "disabled"])
                            ]),
                            _: 1
                          }),
                          ((_ctx.state.etapa.statusVenda !== _ctx.EStatusVenda.Cancelada))
                            ? (_openBlock(), _createBlock(_component_card, {
                                key: 0,
                                titulo: "ESTOQUE"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    class: "ss-check-box",
                                    checked: _ctx.state.etapa.movimentarEstoque,
                                    "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.etapa.movimentarEstoque) = $event)),
                                    disabled: !_ctx.props.editavel
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Realizar saída no estoque")
                                    ]),
                                    _: 1
                                  }, 8, ["checked", "disabled"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          ((_ctx.state.etapa.statusVenda !== _ctx.EStatusVenda.Cancelada))
                            ? (_openBlock(), _createBlock(_component_card, {
                                key: 1,
                                titulo: "FATURAMENTO"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    class: "ss-check-box",
                                    checked: _ctx.state.etapa.executarFaturamento,
                                    "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.etapa.executarFaturamento) = $event)),
                                    disabled: !_ctx.props.editavel
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Executar Faturamento")
                                    ]),
                                    _: 1
                                  }, 8, ["checked", "disabled"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          ((_ctx.state.etapa.statusVenda !== _ctx.EStatusVenda.Cancelada))
                            ? (_openBlock(), _createBlock(_component_card, {
                                key: 2,
                                titulo: "FISCAL"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    class: "ss-check-box",
                                    checked: _ctx.state.etapa.gerarDocFiscal,
                                    "onUpdate:checked": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.etapa.gerarDocFiscal) = $event)),
                                    disabled: !_ctx.props.editavel
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Gerar documento fiscal")
                                    ]),
                                    _: 1
                                  }, 8, ["checked", "disabled"]),
                                  _createVNode(_component_a_checkbox, {
                                    class: "ss-check-box",
                                    checked: _ctx.state.etapa.gerarNfse,
                                    "onUpdate:checked": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.etapa.gerarNfse) = $event)),
                                    disabled: !_ctx.props.editavel
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Gerar NFS-e")
                                    ]),
                                    _: 1
                                  }, 8, ["checked", "disabled"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["visible"]))
}